import { ISetSelfServiceScheduleParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetSubscriptionsSelfServiceScheduleRequest extends Request<ISetSelfServiceScheduleParams, IResult> {
  constructor(params: ISetSelfServiceScheduleParams) {
    super('setSubscriptionsSelfServiceSchedule', params);
  }
}
